export default __webpack_public_path__ + "static/media/img_16.2b26ec6f.jpg";